<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <lcl-search-bar
        :is-query-price="true"
        config-id="PriceLCL"
        :show-currency="false"
        :is-manage-module="true"
        :filter="filter"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditCP" type="primary" :disabled="!this.cpSelectRow" @click="onEdit_CP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDeleteCP" type="primary" @click="onDelete_CP()">{{ $t('Pricing.Invalid') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP0" type="primary" @click="onPriceState_CP(0)">{{ $t('Pricing.PriceState_Common') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP1" type="primary" @click="onPriceState_CP(1)">{{ $t('Pricing.PriceState_Suspend') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(2)">{{ $t('Pricing.PriceState_Reject') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP3" type="primary" @click="onPriceState_CP(3)">{{ $t('Pricing.PriceState_Inquiry') }}</el-button>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditPP" type="primary" :disabled="!this.ppSelectRow" @click="onEdit_PP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" :disabled="!ppSelectLength" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprove" :disabled="!ppSelectLength" type="primary" @click="onApprove()">{{ $t('Pricing.Audit') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP"
            no="saveLclExcelFile"
            :action="URL.price.saveLclExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </lcl-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <lcl-export-remark-data-grid
            ref="cpList"
            :v-if="activeTabName === 'cpList'"
            config-module="224601"
            :row-data="rowCpData"
            :show-create="true"
            :show-modify="true"
            :show-approve="true"
            :show-selection="true"
            :filter="filter"
            :grid-options="cpGridOptions"
            :view="1"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <lcl-export-remark-data-grid
            ref="ppList"
            :v-if="activeTabName === 'ppList'"
            config-module="224602"
            :row-data="rowPpData"
            :show-price-no="false"
            :show-create="true"
            :show-modify="true"
            :show-approve="false"
            :show-selection="true"
            :filter="filter"
            :grid-options="ppGridOptions"
            :view="0"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; left: 160px;margin: 10px;">
        <span>{{ globalMsg }}</span>
      </div>
    </div>
    <lcl-form
      v-if="lclFormDialog.visible"
      :visible="lclFormDialog.visible"
      :price="lclFormDialog.price"
      :is-new="lclFormDialog.isNew"
      :is-cp="activeTabName === 'cpList'"
      @close="onLclFormDialogClose"
      @deleteCp="deleteCp"
      @reload="toQuery"
      @supplierChange="(params)=>supplierChange(params)"
      @warehouseCallback="(params)=>warehouseCallback(params)"
    />
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import {
  approvePriceLcls,
  deletePriceLcls,
  inactivePriceLcls,
  queryEffectivePriceLcl,
  queryPendingPriceLcl,
  updatePriceStateOfPriceLcls
} from '@/api/price/priceLcl'
import DateUtils from '@/utils/dateUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import LclSearchBar from '@/views/cargo/v0/Price/components/query/lclSearchBar'
import LclExportRemarkDataGrid from '@/views/cargo/v0/Price/PriceLCL/components/lclExportRemarkDataGrid'
import LclForm from '@/views/cargo/v0/Price/PriceLCL/components/lclForm'
import { PricingLCLConfigUtil } from '@/class/cargo/model/utils/PricingLCLConfigUtil'
import { deepClone } from '@/utils'

export default {
  name: 'PriceLCL',
  components: {
    LclForm,
    LclExportRemarkDataGrid,
    LclSearchBar },
  data() {
    return {
      URL,
      activeTabName: 'cpList',
      isHQManager: false,
      remarkChange: '',
      targetLevel: 99,
      txtRemarks: '',
      showDetail: false,
      fullscreenLoading: null,
      proxy: {},
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: null,
        endDate: '',
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        dangerous: false,
        isAddon: false,
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false,
        volumeWeightRatio: '',
        destinationAgent: []
      },
      rowCpData: [],
      rowPpData: [],
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      lclFormDialog: {
        visible: false,
        price: {},
        isNew: false
      },
      priceStateRejectDialog: {
        visible: false,
        price: {
          reject20: false,
          reject40: false,
          rejectHC: false,
          reject45: false,
          priceFclUuids: []
        }
      },
      fclMarkupSchemeDialog: {
        visible: false,
        selectedRows: []
      },
      fclMarkupManualDialog: {
        visible: false,
        selectedRows: []
      },
      fclSettingsDialog: {
        visible: false
      },
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      priceLclUtil: null,
      ppSelectLength: 0,
      globalMsg: '' // 条数和勾选条数显示
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PriceLCL', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('PriceLCL')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceLcl')
      this.priceLclUtil = await PricingLCLConfigUtil.getInstance()
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        if (this.isHQManager) {
          this.deleteAllowed_PP = true
        }
        // 改成有批准权限人，就能删除
        this.approveAllowed_PP = this.deleteAllowed_CP = this.priceLclUtil.isApprove
        this.inputAllowed_PP = this.priceLclUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
    },
    onLevelChanged(searchLevel) {
      if (this.isActiveCpTab) {
        this.targetLevel = searchLevel.level
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    onLclFormDialogClose() {
      this.lclFormDialog.visible = false
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      if (this.activeTabName === 'cpList') {
        queryEffectivePriceLcl(this.proxy).then((res) => {
          this.handleQueryData(res.data)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        if (!MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')) {
          this.proxy['branchId'] = this.$store.getters.currentOfficeId
        }
        queryPendingPriceLcl(this.proxy).then((res) => {
          this.handleQueryData(res.data)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    handleQueryData(result) {
      this.loadingEnd()
      if (!result || result.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.setRowData([])
        return
      }
      const count = result.length
      // 只返回部分结果的话，弹窗提醒是否加载更多
      let isMore = false
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
        isMore = true
      }
      if (isMore) {
        result.pop()
      }
      this.setRowData(result)
    },
    setRowData(result) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
      } else {
        this.rowPpData = result
      }
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), result.length)
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
        this.onEdit_CP()
      } else {
        this.ppSelectRow = data
        this.onEdit_PP()
      }
    },
    onEdit_CP() {
      if (!this.cpSelectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      if (Number(this.targetLevel) < 1) {
        this.$message.warning(this.$t('Pricing.onlyViewAndEditCostAreAllow'))
        return
      }
      this.lclFormDialog.visible = true
      this.lclFormDialog.isNew = false
      const newPrice = deepClone(this.cpSelectRow)
      newPrice.destinationAgent = newPrice.destinationAgent.split(',').filter(val => { if (!isNaN(Number(val))) return val }).map(val => Number(val))
      newPrice.transportMode = newPrice.transportMode.split(',')
      newPrice.oldUuid = newPrice.uuid
      delete newPrice['uuid']
      delete newPrice['dateCreated']
      this.lclFormDialog.price = newPrice
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.InvalidSelection'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.deleteCp(selectedRows)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.cpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      if (!this.isHQManager) {
        for (const item of selectedRows) {
          if (item.branchId !== this.$store.getters.currentOfficeId) {
            this.$message.warning(this.$t('Pricing.IsAllowedOperate_DiffBranch'))
            return null
          }
        }
      }
      return selectedRows
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(selectRow) {
      this.fullscreenLoading = getLoading()
      const priceList = []
      for (const item of selectRow) {
        const curPrice = { ...item }
        if (item.oldUuid) {
          curPrice.uuid = item.oldUuid
        }
        priceList.push(curPrice)
      }
      inactivePriceLcls(priceList).then(res => {
        this.$message.success(this.$t('Pricing.Finished'))
        this.cpGridOptions.api.updateRowData({ remove: selectRow })
        this.loadingEnd()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      api.refreshCells({ force: true })
      if (this.isActiveCpTab) {
        this.$refs['cpList'].txtRemarks = ''
      } else {
        this.$refs['ppList'].txtRemarks = ''
        this.ppSelectLength = 0
      }
      this.cpSelectRow = null
      this.ppSelectRow = null
      this.fullscreenLoading.close()
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    onPriceState_CP(state) {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      const stateName = CommonState.getNameByCode(PriceConstant.PRICE_STATE, state)
      const msg = this.$t('Pricing.SuspendSelection')
      this.$confirm(msg.replace('{0}', stateName), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        updatePriceStateOfPriceLcls(selectedRows, { state: state }).then(res => {
          this.$message.success(this.$t('Pricing.Finished'))
          for (const item of selectedRows) {
            item.priceState = state
          }
          this.loadingEnd()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    onEdit_PP() {
      if (!this.ppSelectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.lclFormDialog.visible = true
      this.lclFormDialog.isNew = false
      const newPrice = deepClone(this.ppSelectRow)
      newPrice.destinationAgent = newPrice.destinationAgent.split(',').filter(val => { if (!isNaN(Number(val))) return val }).map(val => Number(val))
      newPrice.transportMode = newPrice.transportMode.split(',')
      this.lclFormDialog.price = newPrice
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRowsPp()
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      const msg = selectedRows.length === 1 ? this.$t('Pricing.IsDeleteRecord') : this.$t('Pricing.IsDeleteRecords')
      this.$confirm(msg, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        deletePriceLcls(uuids).then(res => {
          const api = this.getGridOptionsApi()
          api.updateRowData({ remove: selectedRows })
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.loadingEnd()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    onAdd_PP() {
      this.lclFormDialog.visible = true
      this.lclFormDialog.isNew = true
      this.lclFormDialog.price = {
        state: PriceConstant.PRICE_STATE_PENDING,
        active: false,
        direct: true,
        term: 'P',
        currency: 'USD',
        days: 0,
        freeTime: 0,
        share: 'SELF',
        priceState: 0,
        trend: 0,
        closingDay: '',
        gradeMin: PriceConstant.NIL,
        gradeMax: PriceConstant.NIL,
        costWeightPrice: PriceConstant.NIL,
        costVolumePrice: PriceConstant.NIL,
        threeWeightPrice: PriceConstant.NIL,
        threeVolumePrice: PriceConstant.NIL,
        oneWeightPrice: 0,
        oneVolumePrice: 0,
        twoWeightPrice: 0,
        twoVolumePrice: 0,
        sellVat: 0,
        costVat: 0,
        shareCarrier: 0,
        volumeWeightRatio: 1000,
        transportMode: ['CFS-CFS'],
        destinationAgent: [],
        warehouseVendorCmpIdx: '',
        warehouseVendorUuid: '',
        warehouseUuid: '',
        minRateUnit: '',
        minRateValue: ''
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('LCL_sample.xls', 'price')
    },
    selectRowChange(data) {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    onApprove() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      this.$confirm(this.$t('Pricing.IsApproveRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        if (!this.isAllowedApprove(selectedRows)) return
        this.fullscreenLoading = getLoading()
        approvePriceLcls(selectedRows).then(res => {
          this.loadingEnd()
          this.ppGridOptions.api.updateRowData({ remove: selectedRows })
          this.$message.success(this.$t('Pricing.HasApproved'))
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    isAllowedApprove(selectedRows) {
      if (!this.$store.getters.isAdmin) {
        const officeIds = MultiCompanyUtil.getInstance().getOfficeIDsForApprove('PriceLcl')
        if (!officeIds || officeIds === null || officeIds.length === 0) {
          return false
        }
        if (officeIds[0] === 0) {
          const ofcIDMap = {}
          for (let i = officeIds.length - 1; i >= 1; i--) {
            ofcIDMap[officeIds[i]] = i // ofcIDs中可能存在重复的id，但不影响
          }
          for (const item of selectedRows) {
            if (!ofcIDMap.hasOwnProperty(item.branchId)) {
              this.$confirm(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), item.pol, item.pod), this.$t('Message.Prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
              }).then(() => {
                // 定位到该列
                const api = this.ppGridOptions.api
                api.forEachNode(function(node, index) {
                  if (node.uuid === item.uuid) {
                    api.selectNode(node)
                  }
                })
              })
              return false
            }
          }
        }
      }
      return true
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        this.toQuery()
        return
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    },
    toRefreshSelectedCountChargeGrid() {
      const selRows = this.ppGridOptions.api.getSelectedRows()
      this.ppSelectLength = selRows.length
      this.globalMsg = selRows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), selRows.length) : ''
    },
    supplierChange(params) {
      this.lclFormDialog.price.warehouseVendorCmpIdx = params.value
      this.lclFormDialog.price.warehouseVendorUuid = params.uuid
      this.lclFormDialog.price.warehouseUuid = ''
    },
    warehouseCallback(warehouse) {
      this.lclFormDialog.price.warehouseUuid = warehouse.uuid
    }
  }
}
</script>

<style scoped>

</style>
